import React from "react"
import EventBus from '../../../common/EventBus'

export type Props<T> = {
  eventBus: EventBus
} & T

export default abstract class TextFilterComponent<T> extends React.Component<Props<T>> {
}